import { render, staticRenderFns } from "./commonQ.vue?vue&type=template&id=9317e400&"
import script from "./commonQ.vue?vue&type=script&lang=js&"
export * from "./commonQ.vue?vue&type=script&lang=js&"
import style0 from "./commonQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports